// // import { useMemo, useCallback } from "react";
// // import classes from "./shipment.module.css";

// // import { CustomSelect } from "../../../../component/customSelect/CustomSelect";
// // import { shipmentDetailTableColumnsConfig } from "./shipmentDetailTableColumnsConfig";
// // import { Table } from "../../../../component/table/Table";
// // import { ShipmentStatusBadge } from "../OrderDetailPage";
// // import { StatusBadge } from "../../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailForm";
// // import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

// // export const Shipment = ({ shipment, onChange }) => {
// //   const columnDefs = useMemo(() => {
// //     if (!shipment?.category) return [];

// //     const hasVrp = shipment.category === "VRP";

// //     return shipmentDetailTableColumnsConfig.shipmentDetail(null, null, hasVrp);
// //   }, [shipment?.category]);

// //   const handleStatusSelect = useCallback(
// //     (statusId) => {
// //       if (!statusId || statusId === shipment.status_id) return;

// //       onChange({
// //         shipment_id: shipment.shipment_id,
// //         status: statusId,
// //       });
// //     },
// //     [shipment.shipment_id, shipment.status_id, onChange],
// //   );

// //   const validStatuses = shipment?.shipment_valid_status || [];
// //   const hasMultipleStatuses = validStatuses.length > 1;

// //   return (
// //     <div className={classes.box}>
// //       {/* HEADER */}
// //       <div className={classes.header}>
// //         <h2 className={classes.title}>{shipment?.title}</h2>

// //         <div className={classes.headerBadges}>
// //           <ShipmentStatusBadge status={shipment.status} />
// //         </div>
// //       </div>

// //       {/* ACTIONS */}
// //       <div className={classes.actions}>
// //         {hasMultipleStatuses && (
// //           <div className={classes.actions__wrapper}>
// //             <CustomSelect
// //               placeholder="Change Status"
// //               options={validStatuses}
// //               value={shipment.status_id} // ✅ direct backend control
// //               onChange={handleStatusSelect}
// //             />
// //           </div>
// //         )}

// //         <button className={classes.downloadBtn}>
// //           <ArrowDownTrayIcon className={classes.downloadBtn__icon} />
// //           <span>Download Invoice</span>
// //         </button>
// //       </div>

// //       <Table data={shipment?.items || []} columns={columnDefs} />
// //     </div>
// //   );
// // };
import { useMemo, useCallback } from "react";
import classes from "./shipment.module.css";

import { CustomSelect } from "../../../../component/customSelect/CustomSelect";
import { shipmentDetailTableColumnsConfig } from "./shipmentDetailTableColumnsConfig";
import { Table } from "../../../../component/table/Table";
import { ShipmentStatusBadge } from "../OrderDetailPage";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useLazyDownloadInvoiceQuery } from "../../../../services/orderDetailApiSlice";
export const Shipment = ({ shipment, orderId, onChange }) => {
  const [triggerDownload, { isFetching }] = useLazyDownloadInvoiceQuery();
  const hasInvoice = useMemo(() => {
    if (shipment?.invoice_url) return true;

    return shipment?.items?.some((item) => item?.invoice_url);
  }, [shipment]);
  const columnDefs = useMemo(() => {
    if (!shipment?.category) return [];

    const hasVrp = shipment.category === "VRP";

    return shipmentDetailTableColumnsConfig.shipmentDetail(null, null, hasVrp);
  }, [shipment?.category]);

  // 🔥 FIXED FUNCTION (UI same, logic updated)
  const handleStatusSelect = useCallback(
    (statusId) => {
      if (!statusId || statusId === shipment.status_id) return;

      const selectedStatus = shipment.shipment_valid_status.find(
        (s) => Number(s.id) === Number(statusId),
      );
      
      onChange({
        shipment_id: shipment.shipment_id,
        status: Number(statusId),
        statusLabel: selectedStatus?.label,
        currentStatus: shipment.status,
      });
    },
    [shipment, onChange],
  );
  const handleDownloadInvoice = async () => {
    try {
      const res = await triggerDownload({
        orderId,
        shipment_id: shipment.shipment_id,
      }).unwrap();

      const url = res?.data?.invoice_url;

      if (!url) return;

      window.open(url, "_blank");
    } catch (err) {
      console.error("Download failed", err);
    }
  };
  // const handleDownloadInvoice = () => {
  //   const url =
  //     shipment?.invoice_url ||
  //     shipment?.items?.find((i) => i?.invoice_url)?.invoice_url;

  //   if (!url) return;

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.target = "_blank";
  //   link.download = "invoice.pdf";
  //   link.click();
  // };
  const validStatuses = shipment?.shipment_valid_status || [];
  const hasMultipleStatuses = validStatuses.length > 1;

  return (
    <div className={classes.box}>
      {/* HEADER */}
      <div className={classes.header}>
        <h2 className={classes.title}>{shipment?.title}</h2>

        <div className={classes.headerBadges}>
          <ShipmentStatusBadge status={shipment.status} />
        </div>
      </div>

      {/* ACTIONS */}
      <div className={classes.actions}>
        {hasMultipleStatuses && (
          <div className={classes.actions__wrapper}>
            <CustomSelect
              placeholder="Change Status"
              options={validStatuses}
              value={shipment.status_id}
              onChange={handleStatusSelect}
            />
          </div>
        )}

        {/* UI SAME */}
        {hasInvoice && (
          <button
            className={classes.downloadBtn}
            onClick={handleDownloadInvoice}
            disabled={isFetching}
          >
            <ArrowDownTrayIcon className={classes.downloadBtn__icon} />
            <span>{isFetching ? "Downloading..." : "Download Invoice"}</span>
          </button>
        )}
        {/* <button className={classes.downloadBtn}>
          <ArrowDownTrayIcon className={classes.downloadBtn__icon} />
          <span>Download Invoice</span>
        </button> */}
      </div>

      <Table data={shipment?.items || []} columns={columnDefs} />
    </div>
  );
};


